import Map from "@/components/Map";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { MapStateProvider } from "@/contexts/MapStateContext";
import { ClientEvents, TrackerPosition } from "@/interfaces";
import { useState } from "react";

interface TravelPositionsDialogProps {
  positions: TrackerPosition[];
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  period: string;
  vehicleTitle: string;
  isLoading?: boolean;
  driversWithColors?: Array<{
    name: string;
    color: string;
  }>;
  events?: ClientEvents[];
}

export function TravelPositionsDialog({
  positions,
  open,
  onOpenChange,
  period,
  vehicleTitle,
  isLoading = false,
  driversWithColors,
  events,
}: TravelPositionsDialogProps) {
  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = open !== undefined;
  const isOpen = isControlled ? open : internalOpen;
  const handleOpenChange = isControlled ? onOpenChange : setInternalOpen;

  if (isLoading) {
    return (
      <Dialog open={isOpen} onOpenChange={handleOpenChange}>
        <DialogContent className="sm:max-w-4xl">
          <DialogHeader>
            <DialogTitle className="text-foreground">
              <div className="flex gap-2 items-center">
                <h2 className="text-lg font-semibold">{vehicleTitle}</h2>
              </div>
              <p className="text-gray-500 text-sm mt-1">{period}</p>
            </DialogTitle>
          </DialogHeader>
          <div className="flex flex-col items-center justify-center w-full h-[500px] bg-muted animate-pulse">
            <div className="w-10 h-10 border-4 border-gray-200 dark:border-gray-700 border-t-blue-500 rounded-full animate-spin"></div>
            <span className="mt-4 text-slate-600 dark:text-slate-400 font-medium">
              Carregando...
            </span>
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-4xl">
        <DialogHeader>
          <DialogTitle className="text-foreground">
            <div>
              <div className="flex gap-2 items-center">
                <h2 className="text-lg font-semibold">{vehicleTitle}</h2>
              </div>
              <p className="text-gray-500 text-sm mt-1">{period}</p>
            </div>
          </DialogTitle>
        </DialogHeader>
        <div className="w-full h-[500px]">
          <div className="h-full bg-muted">
            <MapStateProvider>
              <Map
                positions={positions}
                showAnimation={true}
                driversWithColors={driversWithColors}
                events={events}
                displayEventsAndMarkersOptions={true}
              />
            </MapStateProvider>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default TravelPositionsDialog;
